export enum ColorTheme {
  green = "#b8eecd",
  darkGreen = "#1b3a1c",
  iconStrong = "#03542D",
  default = "#5b0337",
  black = "black",
  white = "#ffffff",
  bgExtraLight = "#F4F0EF",
  borderWeaker = "#879787",
  burgundy17 = "#9a658b",
  textNeutral = "#666666",
  insightDarkBlue = "#091354",
  insightDarkBlue13 = "#bdc0d6",
  insightDarkBlue18 = " #3a4276",
  insightPurple1 = "#cec1ff",
}
